import React, { FC, useEffect, useState } from 'react';
import { useFetch } from '../../../shared/hooks';
import apiRoutes from '../../../../config/api/routes';
import { getSeriesMapper } from '../../../../config/api/models';
import { useTranslation } from 'react-i18next';
import { Loading, Paragraph } from '../../../shared/components';
import SeriesList from './SeriesList';
import { AddSeriesForm } from './AddSeriesForm';
import { useParams } from 'react-router';
import { ExerciseSeriesType } from '../../../../config/api/models/Exercise';
import { UrlParams } from '../../../shared/types';

type Props = {
  type: ExerciseSeriesType;
  isTrajectoryViewEditMode?: boolean;
};

const SeriesListContainer: FC<Props> = ({ type, isTrajectoryViewEditMode = false }) => {
  const { trajectoryId } = useParams<UrlParams>();
  const [exercisesSeries, setExercisesSeries] = useState<any>(null);
  const [getSeriesResponse, getSeries] = useFetch(apiRoutes.pages(trajectoryId as string, type), {
    mapper: getSeriesMapper,
  });
  const { t } = useTranslation();

  useEffect(() => {
    getSeries();
  }, [getSeries, type]);

  useEffect(() => {
    if (getSeriesResponse.success) {
      setExercisesSeries(getSeriesResponse.data);
    }
  }, [getSeriesResponse, setExercisesSeries]);

  const updateSeries = () => {
    getSeries();
  };

  return exercisesSeries ? (
    <>
      <Paragraph>{t(`trajectory.sections.${type}.intro`)}</Paragraph>
      <SeriesList
        type={type}
        data={exercisesSeries}
        onDeleteSeries={updateSeries}
        onPatchSeries={updateSeries}
        isTrajectoryViewEditMode={isTrajectoryViewEditMode}
      />
      <AddSeriesForm type={type} onAddSeries={updateSeries} />
    </>
  ) : (
    <Loading />
  );
};

export default SeriesListContainer;
